export default "__VITE_ASSET__DeQpvCbZ__"